export default "__VITE_ASSET__6eece49e__"